var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddCircle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM12 6.10714C12.6509 6.10714 13.1786 6.63481 13.1786 7.28571V10.8214H16.7143C17.3652 10.8214 17.8929 11.3491 17.8929 12C17.8929 12.6509 17.3652 13.1786 16.7143 13.1786H13.1786V16.7143C13.1786 17.3652 12.6509 17.8929 12 17.8929C11.3491 17.8929 10.8214 17.3652 10.8214 16.7143V13.1786H7.28571C6.63481 13.1786 6.10714 12.6509 6.10714 12C6.10714 11.3491 6.63481 10.8214 7.28571 10.8214H10.8214V7.28571C10.8214 6.63481 11.3491 6.10714 12 6.10714Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AddCircle.3a4c2f6bc3165ba71b0c8b1625b8d77d.svg";